<section class="redial-bg-dark py-5">
    <div class="container">
        <div class="row">
            <div class="col-5 mx-auto">
               <div class="jumbotron mb-0 text-center bg-white rounded">
                    <h1 class="display-3 redial-font-weight-800"> 404</h1>
                    <h5><i class="fa fa-warning pr-2"></i>Oops! Something went wrong</h5>
                    <p>The page you are looking for is not found, please try after some time or go back to home</p>
                    <a  href="/home" class="btn btn-primary btn-sm">Go To Home</a>
                </div>
            </div>
        </div>
    </div>
</section>